import { type EmployeeDetails, type EmployeeTeam, type EmployeeDetailsSupportedRoles } from '@makemydeal/dr-dash-types';
import isEqual from 'lodash/isEqual';

export const normalizeEmployeeDetails = (employee: EmployeeDetails): EmployeeDetails => ({
    employeeDmsId: employee.employeeDmsId?.trim() || undefined,
    employeeRole: employee.employeeRole,
    name: {
        firstName: employee.name?.firstName?.trim() || '',
        lastName: employee.name?.lastName?.trim() || ''
    }
});

export const roleCarriesData = (employee: EmployeeDetails | undefined): boolean =>
    Boolean(employee?.name?.firstName?.trim() || employee?.name?.lastName?.trim() || employee?.employeeDmsId?.trim());

export const hasUnsavedEmployeeChanges = (
    employeeDetails: EmployeeTeam,
    reduxEmployeeDetails: EmployeeTeam,
    roleTitleMap: Record<string, string>
): boolean => {
    const roles = Object.keys(roleTitleMap) as EmployeeDetailsSupportedRoles[];

    const normalizeGroup = (employeeGroup: EmployeeTeam): Partial<EmployeeTeam> => {
        const filtered: Partial<EmployeeTeam> = {};

        for (const role of roles) {
            const employee = employeeGroup[role];
            if (roleCarriesData(employee)) {
                filtered[role] = normalizeEmployeeDetails(employee as EmployeeDetails);
            }
        }

        return filtered;
    };

    return !isEqual(normalizeGroup(employeeDetails), normalizeGroup(reduxEmployeeDetails));
};
